
export class EventManager {

	prefix: string;
	listeners: object;
	private static instance: EventManager;

	constructor() {
		this.prefix = 'on_';
		this.listeners = {};
	}

	static get Instance() {

		if (this.instance === null || this.instance === undefined) {
			this.instance = new EventManager();
		}

		return this.instance;

	}

	register(eventName: string, bind: string, callback: Function) {

		const currentEventName = `${this.prefix}${eventName}`;

		if (typeof this.listeners[currentEventName] === 'undefined') {
			this.listeners[currentEventName] = [];
		}

		this.listeners[currentEventName].push([bind === null ? this : bind, callback]);

	}

	emit(eventName: string, data: object = {}) {

		const currentEventName = `${this.prefix}${eventName}`;

		if (typeof this.listeners[currentEventName] !== 'undefined') {

			this.listeners[currentEventName].forEach((element, index) => {

				this.listeners[currentEventName][index][1].call(
					this.listeners[currentEventName][index][1],
					eventName,
					data
				);

			});

		}

	}

}



// WEBPACK FOOTER //
// ./services/event-manager.service.ts